import { Reducer } from 'react';
import { Actions } from '../../actions/assetLoadManagementList';
import { Action, LoadManagementListState, AssetLoadManagementListState } from '../../types';
import FilterItem from '../../../components/Filter/FilterItem';
import { AssetLoadManagementFilterTypeEnum } from '../../../types/AssetLoadManagementFilterType';

const initialAssetLoadManagementListState: AssetLoadManagementListState = {
    filters: {
        jobIds: [],
        regionIds: [],
        statuses: [], 
        trailerTypeIds: [],
        equipmentTypeIds: [],
        loadTypeIds: [],
        driverIds: [],
        carrierIds: [],
        fromDate: '',
        toDate: '',
        equipmentId: '',
    },
    searchPhraseSubset: {
        jobSubset: { subset: [], searchPhrase: '' },
        regionSubset: { subset: [], searchPhrase: '' },
        statusSubset: { subset: [], searchPhrase: '' }, //load
        trailerTypeSubset: { subset: [], searchPhrase: '' },
        equipmentTypeSubset: { subset: [], searchPhrase: '' },
        loadTypeSubset: { subset: [], searchPhrase: '' },
        driverSubset: { subset: [], searchPhrase: '' },
        carrierSubset: { subset: [], searchPhrase: '' },
    },
    searchPhrase: '',
};

interface FilterObject {
    filterType: string;
    id: number;
    isSelected: boolean;
}

const setDateRangeFilters = (
    payload: { fromDate: string; toDate: string },
    state: AssetLoadManagementListState,
): AssetLoadManagementListState => {
    return {
        ...state,
        filters: {
            ...state.filters,
            fromDate: payload.fromDate,
            toDate: payload.toDate,
        },
    };
};

const addOrRemoveFilters = (payload: FilterObject, filters: number[]): number[] => {
    let massagedFilter: number[] = [];
    massagedFilter = massagedFilter.concat(filters);
    if (payload.isSelected) {
        massagedFilter.push(payload.id);
    } else {
        massagedFilter = filters.filter((id): any => {
            if (id !== payload.id) return id;

            return undefined;
        });
    }

    return massagedFilter;
};

const addOrRemoveSelectAllFilters = (itemIds: number[], filters: number[], selected: boolean): number[] => {
    const massagedFilter: number[] = [];
    if (!selected) {
        return [];
    } else {
        return massagedFilter.concat(itemIds);
    }
};

const updateFilterListForSearchPhrase = (items: { id: number; name: string }[], searchString: string): FilterItem[] => {
    return items.filter(item => item.name.toLowerCase().includes(searchString.toLowerCase()));
};

const setSelectedFilters = (payload: FilterObject, state: AssetLoadManagementListState): AssetLoadManagementListState => {
    const { filters } = state;
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.EQUIPMENT) {
        // filters.equipmentId = addOrRemoveFilters(payload, filters.jobIds);
    }

    if (payload.filterType === AssetLoadManagementFilterTypeEnum.JOB) {
        filters.jobIds = addOrRemoveFilters(payload, filters.jobIds);
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.DRIVER) {
        filters.driverIds = addOrRemoveFilters(payload, filters.driverIds);
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.CARRIER) {
        filters.carrierIds = addOrRemoveFilters(payload, filters.carrierIds);
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.STATUS) {
        filters.statuses = addOrRemoveFilters(payload, filters.statuses);
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.REGION) {
        filters.regionIds = addOrRemoveFilters(payload, filters.regionIds);
    }

    if (payload.filterType === AssetLoadManagementFilterTypeEnum.EQUIPMENTTYPE) {
        filters.equipmentTypeIds = addOrRemoveFilters(payload, filters.equipmentTypeIds);
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.LOADTYPE) {
        filters.loadTypeIds = addOrRemoveFilters(payload, filters.loadTypeIds);
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.TRAILER) {
        filters.trailerTypeIds = addOrRemoveFilters(payload, filters.trailerTypeIds);
    }

    return {
        ...state,
        filters: { ...filters },
    };
};

// TODO: Generisize these two methods to take in the action type and reduce use of chained if statements
const setSelectAllFilters = (
    payload: { itemIds: number[]; filterType: string },
    state: AssetLoadManagementListState,
): AssetLoadManagementListState => {
    const { filters } = state;

    const filterCopy = { ...filters };
    
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.DRIVER) {
        filterCopy.driverIds = addOrRemoveSelectAllFilters(
            payload.itemIds,
            filterCopy.driverIds,
            !(filterCopy.driverIds.length > 0),
        );
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.CARRIER) {
        filterCopy.carrierIds = addOrRemoveSelectAllFilters(
            payload.itemIds,
            filterCopy.carrierIds,
            !(filterCopy.carrierIds.length > 0),
        );
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.STATUS) {
        filterCopy.statuses = addOrRemoveSelectAllFilters(
            payload.itemIds,
            filterCopy.statuses,
            !(filterCopy.statuses.length > 0),
        );
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.REGION) {
        filterCopy.regionIds = addOrRemoveSelectAllFilters(
            payload.itemIds,
            filterCopy.regionIds,
            !(filterCopy.regionIds.length > 0),
        );
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.EQUIPMENTTYPE) {
        filterCopy.equipmentTypeIds = addOrRemoveSelectAllFilters(
            payload.itemIds,
            filterCopy.equipmentTypeIds,
            !(filterCopy.equipmentTypeIds.length > 0),
        );
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.LOADTYPE) {
        filterCopy.loadTypeIds = addOrRemoveSelectAllFilters(
            payload.itemIds,
            filterCopy.loadTypeIds,
            !(filterCopy.loadTypeIds.length > 0),
        );
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.TRAILER) {
        filterCopy.trailerTypeIds = addOrRemoveSelectAllFilters(
            payload.itemIds,
            filterCopy.trailerTypeIds,
            !(filterCopy.trailerTypeIds.length > 0),
        );
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.JOB) {
        filterCopy.jobIds = addOrRemoveSelectAllFilters(payload.itemIds, filterCopy.jobIds, !(filterCopy.jobIds.length > 0));
    }
    return {
        ...state,
        filters: { ...filterCopy },
    };
};

const setFilterSearchPhrase = (
    payload: { items: FilterItem[]; filterType: string; searchPhrase: string },
    state: AssetLoadManagementListState,
): AssetLoadManagementListState => {
    const { searchPhraseSubset } = state;
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.DRIVER) {
        searchPhraseSubset.driverSubset = {
            subset: updateFilterListForSearchPhrase(payload.items, payload.searchPhrase),
            searchPhrase: payload.searchPhrase,
        };
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.CARRIER) {
        searchPhraseSubset.carrierSubset = {
            subset: updateFilterListForSearchPhrase(payload.items, payload.searchPhrase),
            searchPhrase: payload.searchPhrase,
        };
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.STATUS) {
        searchPhraseSubset.statusSubset = {
            subset: updateFilterListForSearchPhrase(payload.items, payload.searchPhrase),
            searchPhrase: payload.searchPhrase,
        };
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.REGION) {
        searchPhraseSubset.regionSubset = {
            subset: updateFilterListForSearchPhrase(payload.items, payload.searchPhrase),
            searchPhrase: payload.searchPhrase,
        };
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.EQUIPMENTTYPE) {
        searchPhraseSubset.equipmentTypeSubset = {
            subset: updateFilterListForSearchPhrase(payload.items, payload.searchPhrase),
            searchPhrase: payload.searchPhrase,
        };
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.LOADTYPE) {
        searchPhraseSubset.loadTypeSubset = {
            subset: updateFilterListForSearchPhrase(payload.items, payload.searchPhrase),
            searchPhrase: payload.searchPhrase,
        };
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.TRAILER) {
        searchPhraseSubset.trailerTypeSubset = {
            subset: updateFilterListForSearchPhrase(payload.items, payload.searchPhrase),
            searchPhrase: payload.searchPhrase,
        };
    }
    if (payload.filterType === AssetLoadManagementFilterTypeEnum.JOB) {
        searchPhraseSubset.jobSubset = {
            subset: updateFilterListForSearchPhrase(payload.items, payload.searchPhrase),
            searchPhrase: payload.searchPhrase,
        };
    }

    return {
        ...state,
        searchPhraseSubset: { ...searchPhraseSubset },
    };
};

const setFilterEquipmentPhrase = (search: string, state: any) => {
    const { filters } = state;
    return {
        ...state,
        filters: { ...filters, equipmentId: search }
    }
}

const setSearchPhrase = (search: string, state: any): any => {
    return {
        ...state,
        searchPhrase: search,
    };
};

const resetFilterState = (state: AssetLoadManagementListState) => {
    return {
        ...state,
        filters: {
            jobIds: [],
            regionIds: [],
            statuses: [],
            trailerTypeIds: [],
            equipmentTypeIds: [],
            loadTypeIds: [],
            driverIds: [],
            carrierIds: [],
            fromDate: '',
            toDate: '',
            equipmentId: "",
        },
        searchPhraseSubset: {
            jobSubset: { subset: [], searchPhrase: '' },
            statusSubset: { subset: [], searchPhrase: '' },
            driverSubset: { subset: [], searchPhrase: '' },
            carrierSubset: { subset: [], searchPhrase: '' },
            regionSubset: { subset: [], searchPhrase: '' },
            trailerTypeSubset: { subset: [], searchPhrase: '' },
            equipmentTypeSubset: { subset: [], searchPhrase: '' },
            loadTypeSubset: { subset: [], searchPhrase: '' },
        },
        searchPhrase: '',
    };
};

const assetLoadManagementListReducer: Reducer<AssetLoadManagementListState, Action> = (
    state,
    action,
): AssetLoadManagementListState => {
    let newState = { ...state };

    switch (action.type) {
        case Actions.UPDATE_FILTERS:
            newState = setSelectedFilters(action.payload, state);
            break;
        case Actions.UPDATE_FILTER_SEARCH_PHRASE:
            newState = setFilterSearchPhrase(action.payload, state);
            break;
        case Actions.UPDATE_FILTERS_SELECT_ALL:
            newState = setSelectAllFilters(action.payload, state);
            break;
        case Actions.UPDATE_SEARCH_PHRASE:
            newState = setSearchPhrase(action.payload, state);
            break;
        case Actions.UPDATE_FILTER_EQUIPMENT_SEARCH_PHRASE:
            newState = setFilterEquipmentPhrase(action.payload, state);
            break;
        case Actions.UPDATE_DATE_RANGE_FILTERS:
            newState = setDateRangeFilters(action.payload, state);
            break;
        case Actions.REFRESH_ASSET_LOADMANAGEMENT_FILTERS:
            newState = resetFilterState(state);
    }

    return newState;
};

export { initialAssetLoadManagementListState, assetLoadManagementListReducer };
